import SubstanceService from '../../services/SubstanceService';

export default {
    state: {
        collection: [],
    },
    getters: {
        getAllSubstances: store => store.collection,
        getAllSubstancesFromDatetime: (store, getters) => (date = window.moment()) => getters.getAllSubstances.filter((note) => {
            if (note.publishedDate === null && note.nextPublishedDate === null) {
                return false;
            }

            const first = window.moment(note.publishedDate).isSameOrBefore(window.moment(date));
            const second = window.moment(note.nextPublishedDate).isSameOrBefore(window.moment(date));
            return first || second;
        }),
        getSingleSubstance: store => (id) => {
            const items = store.collection.filter(substance => substance.id === id);

            return items.length > 0 ? items[0] : {};
        },
    },
    mutations: {
        loadSubstances(state, payload) {
            state.collection = payload;
        },
    },
    actions: {
        async loadSubstances(context) {
            try {
                const payload = await SubstanceService.getAll();
                context.commit('loadSubstances', payload);
                return payload;
            } catch (error) {
                throw Error(error.message);
            }
        },
    },
    namespaced: true,
};
